var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header"},[_c('div',{staticClass:"row-fluid"}),_c('nav',{staticStyle:{"display":"flex"}})])}]

export { render, staticRenderFns }